document.addEventListener("DOMContentLoaded", async () => {
    const secretKey = getQueryParam('key');
    const contentWrapper = document.querySelector('.content-wrapper-agreement');
    const notification = document.getElementById("notification");
    const vendorHead = document.getElementById("vendorHead");
    const threeBody = document.querySelector(".loader-new");
    const passportfield = document.getElementById("passport");
    const tradefield = document.getElementById("trade-vat");
    const filesSection = document.getElementById("filesSection");
    const rqstedChanges = document.getElementById("rqstedChanges");
    const comments = document.getElementById("comments");
    const ulTaskItems = document.querySelector('ul.items');
    const submitBtn = document.getElementById('submitBtn');
    const loader = document.querySelector(".spinner-border");

    const agreeCheckbox = document.getElementById('agreeCheckbox');
    const signatureField = document.getElementById("signatureName");
    let adminRequestedChanges = false;
    let applicationType = "";

    // Helper function to check if file is HEIC format
    function isHeicFile(file) {
        if (!file) return false;
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        return fileExtension === '.heic' || fileExtension === '.heif' || 
               file.type === 'image/heic' || file.type === 'image/heif' ||
               file.type === 'application/octet-stream' && (fileExtension === '.heic' || fileExtension === '.heif');
    }

    // Helper function to create file with correct content-type for HEIC
    async function prepareFileForUpload(file) {
        if (isHeicFile(file)) {
            // Create a new Blob with the correct MIME type
            const fileData = await file.arrayBuffer();
            const blob = new Blob([fileData], { type: 'image/heic' });
            // Create a new File object with the correct type
            return new File([blob], file.name, { type: 'image/heic', lastModified: file.lastModified });
        }
        return file;
    }

    try {
        const response = await fetch(`https://ejuno.skylinxtech.co/api/vendor-applications/secret/${secretKey}`);
        const responseData = await response.json();

        if (!response.ok) {
            contentWrapper.style.display = "none";
            if (response.status == 404) {
                vendorHead.innerHTML = "Vendor Application doesn't exist!";
            }
            vendorHead.style.display = "block";
            threeBody.style.display = "none";
            filesSection.style.display = "none";
            rqstedChanges.style.display = "none";
            ulTaskItems.style.display = "none";
        } else if (responseData.data.adminStatus === "requested_changes") {
          console.log("reached");
            adminRequestedChanges = true;
            contentWrapper.style.display = "none";
            vendorHead.style.display = "none";
            threeBody.style.display = "none";
            filesSection.style.display = "block";
            rqstedChanges.style.display = "block";
            comments.innerHTML = responseData.data.comments;
            applicationType = responseData.data.applicationType;

            if (applicationType === "individual") {
                passportfield.style.display = "block";
                tradefield.style.display = "none";
            } else {
                passportfield.style.display = "none";
                tradefield.style.display = "block ";
            }

            document.querySelector('.content-area').style.display = "none";
            document.querySelector('.contract__data__section').style.paddingTop = 0;

            if (responseData.data.documents) {
                let fileElements = [];
                responseData.data.documents.forEach(item => {
                    let fileInput = document.getElementById(item.name);
                    if (!fileInput) return;
                   const isPending = item.status === undefined || item.status === "pending";
                    fileInput.parentNode.style.display = isPending ? "block" : "none";
                    if (isPending) {
                        fileElements.push(fileInput);
                    }
                });

                requestedChangesSubmitButton(fileElements);
            }

            if (responseData.data.signatureName && responseData.data.signatureName !== '') {
                document.getElementById("signatureName").value = responseData.data.signatureName;
            }

            if (responseData.data.agreementSigned) {
                agreeCheckbox.checked = true;
                agreeCheckbox.disabled = true;
            }

            signatureField.disabled = true;
            submitBtn.disabled = true;
            ulTaskItems.style.display = "none";
        } else {
            const data = responseData.data;
            threeBody.style.display = "none";

            if (data.vendorStatus == "pending" && data.adminStatus == "pending" && !data.agreementSigned) {
                contentWrapper.style.display = "block";
                vendorHead.style.display = "none";
                rqstedChanges.style.display = "none";
                filesSection.style.display = "block";
                applicationType = data.applicationType;

                if (applicationType === "individual") {
                    passportfield.style.display = "block";
                    tradefield.style.display = "none";
                } else {
                    passportfield.style.display = "none";
                    tradefield.style.display = "block ";
                }

                ulTaskItems.style.display = "block";
                submitBtn.disabled = true;
                markTasks();
            } else if (data.vendorStatus == "accepted" && data.adminStatus == "pending" && data.agreementSigned) {
                vendorHead.innerHTML = "Your application is Waiting for Approval! If you want to get any information, please contact eJuno.";
                vendorHead.style.display = "block";
            } else if (data.vendorStatus == "accepted" && data.adminStatus == "accepted" && data.agreementSigned) {
                vendorHead.innerHTML = "Your application is already Approved! If you want to get any information, please contact eJuno.";
                vendorHead.style.display = "block";
                 const encodedEmail = encodeURIComponent(data.email);
                    const redirectUrl = `https://vendorejuno.web.app/vendors-signup?email=${encodedEmail}`;
                    window.location.href = redirectUrl;
                
            } else if (data.vendorStatus == "accepted" && data.adminStatus == "rejected" && data.agreementSigned) {
                vendorHead.innerHTML = "Application has been Rejected! If you want to get any information, please contact eJuno.";
                vendorHead.style.display = "block";
            } else {
                vendorHead.innerHTML = "";
                vendorHead.style.display = "block";
            }
        }
    } catch (error) {
        showNotification("Network error occurred. Please try again.", true);
        contentWrapper.style.display = "none";
    }

    function onCheckAgree() {
        if (agreeCheckbox.checked && signatureField.value != '') {
            submitBtn.style.backgroundColor = '#30398a';
            submitBtn.disabled = false;
        } else {
            submitBtn.style.backgroundColor = '#ccc';
            submitBtn.disabled = true;
        }
    }

    agreeCheckbox.addEventListener('change', onCheckAgree);

    signatureField.addEventListener('input', () => {
        if (agreeCheckbox.checked && signatureField.value != '') {
            submitBtn.style.backgroundColor = '#30398a';
            submitBtn.disabled = false;
        } else {
            submitBtn.style.backgroundColor = '#ccc';
            submitBtn.disabled = true;
        }
    });

    submitBtn.addEventListener('click', async () => {
        submitBtn.style.backgroundColor = '#ccc';
        submitBtn.disabled = true;

        const signatureName = document.getElementById("signatureName").value;
        const passportID = document.getElementById("PASSPORT_ID").files[0];
        const tradeLicense = document.getElementById("TRADE_LICENSE").files[0];

        const formData = new FormData();
        formData.append('signatureName', signatureName);

        if (applicationType === "individual") {
            if (passportID) {
                const preparedFile = await prepareFileForUpload(passportID);
                formData.append('PASSPORT_ID', preparedFile);
            }
            if (!adminRequestedChanges && !passportID) {
                showNotification("Please provide Passport ID", true);
                submitBtn.style.backgroundColor = '#30398a';
                submitBtn.disabled = false;
                return;
            }
        } else if (applicationType === "business") {
            if (tradeLicense) {
                const preparedFile = await prepareFileForUpload(tradeLicense);
                formData.append('TRADE_LICENSE', preparedFile);
            }
            if (!adminRequestedChanges && !tradeLicense) {
                showNotification("Please provide Trade License", true);
                submitBtn.style.backgroundColor = '#30398a';
                submitBtn.disabled = false;
                return;
            }
        }

        try {
            loader.classList.add("btn-loader");

            const response = await fetch(`https://ejuno.skylinxtech.co/api/vendor-applications/secret/${secretKey}`, {
                method: 'PATCH',
                body: formData
            });

            const responseBody = await response.json();
            loader.classList.remove("btn-loader");

            if (response.ok) {
                showNotification('Files submitted successfully!');
                window.location.href = '/pages/thankyou';
                clearSessionStorageTasksCompletion();
            } else {
                showNotification(responseBody.message, true);
                submitBtn.style.backgroundColor = '#30398a';
                submitBtn.disabled = false;
            }
        } catch (error) {
            showNotification('Network error occurred. Please try again.', true);
            submitBtn.style.backgroundColor = '#30398a';
            submitBtn.disabled = false;
        }
    });

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function clearSessionStorageTasksCompletion() {
        sessionStorage.removeItem('read_agreement');
    }

    function showNotification(message, isError = false) {
        notification.textContent = message;
        notification.classList.toggle("error", isError);
        notification.style.display = "block";
        setTimeout(() => { notification.style.display = "none"; }, 3000);
    }

    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

   function previewImage(input, previewContainer, imageContainerHeading) {
    const file = input.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const imgWrapper = document.createElement('div');
            imgWrapper.classList.add('image-preview');

            const img = document.createElement('img');

           
           if (file.type === "application/pdf") {
    img.src = "https://cdn.shopify.com/s/files/1/0814/3061/0213/files/unnamed.png?v=1756379042";
} else if (
    file.type === "application/msword" || 
    file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
) {
    img.src = "https://cdn.shopify.com/s/files/1/0814/3061/0213/files/text-file-format-icon-in-color-office-report-presentation-vector.jpg?v=1762443632";
} else {
    img.src = e.target.result;
}


            const removeBtn = document.createElement('span');
            removeBtn.innerHTML = '<i class="fas fa-times"></i>';
            removeBtn.classList.add('remove-btn');
            removeBtn.onclick = () => {
                previewContainer.removeChild(imgWrapper);
                input.value = '';
                const event = new CustomEvent('fileCleared', { detail: { input } });
                input.dispatchEvent(event);
            };

            const p = document.createElement('p');
            p.innerHTML = `<strong></strong>`;

            imgWrapper.appendChild(p);
            imgWrapper.appendChild(img);
            imgWrapper.appendChild(removeBtn);

            previewContainer.innerHTML = '';
            previewContainer.appendChild(imgWrapper);
        };

       
        if (file.type !== "application/pdf") {
            reader.readAsDataURL(file);
        } else {
            reader.onload({ target: { result: "" } });
        }
    }
}


    document.getElementById("PASSPORT_ID").addEventListener("change", function () {
        previewImage(this, document.getElementById("passportPreview"), "Passport Document");
    });

    document.getElementById("TRADE_LICENSE").addEventListener("change", function () {
        previewImage(this, document.getElementById("tradePreview"), "Trade License Document");
    });

    function markTasks() {
        let visibleStatus = sessionStorage.getItem('read_agreement');
        let elementToObserve = document.querySelector(".end-of-agreement");
        let taskList = document.querySelectorAll('.items > li');

        let observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                sessionStorage.setItem('read_agreement', true);
                markFirstElement();
                observer.disconnect();
            }
        });

        if (!visibleStatus) {
            observer.observe(elementToObserve);
        } else {
            markFirstElement();
        }

        function markFirstElement() {
            let first = taskList[0];
            first.classList.add('done');
            first.children[0].checked = true;
        }

        let fileElements = document.querySelectorAll('.file-input');
        let files = {};

        function markSecondElement() {
            let flag = true;
            const entries = Object.entries(files);
            const itemsToCheck = applicationType === "individual" ? entries.slice(0, 1) : entries.slice(1);

            for (const [_, value] of itemsToCheck) {
                if (value <= 0) {
                    flag = false;
                }
            }

            let second = taskList[1];
            second.classList.toggle('done', flag);
            second.children[0].checked = flag;

            signatureField.disabled = !flag;
            agreeCheckbox.disabled = !flag;

            if (agreeCheckbox.checked && signatureField.value != '' && flag) {
                submitBtn.style.backgroundColor = '#30398a';
                submitBtn.disabled = false;
            } else {
                submitBtn.style.backgroundColor = '#ccc';
                submitBtn.disabled = true;
            }
        }

        fileElements.forEach(function (element) {
            files[element.id] = 0;
            element.addEventListener("change", function () {
                files[this.id] = this.files.length;
                markSecondElement();
            });
            element.addEventListener("fileCleared", function () {
                files[this.id] = this.files.length;
                markSecondElement();
            });
        });

        signatureField.addEventListener('input', function () {
            let third = taskList[2];
            third.classList.toggle('done', this.value != "");
            third.children[0].checked = this.value != "";
        });

        signatureField.disabled = true;
        agreeCheckbox.disabled = true;
    }

    function requestedChangesSubmitButton(fileElements) {
        let files = {};
        fileElements.forEach(function (element) {
            files[element.id] = 0;
            element.addEventListener("change", function () {
                files[this.id] = this.files.length;
                checkFileStatuses();
            });
            element.addEventListener("fileCleared", function () {
                files[this.id] = this.files.length;
                checkFileStatuses();
            });
        });

        function checkFileStatuses() {
            let flag = true;
            const entries = Object.entries(files);
            for (const [_, value] of entries) {
                if (value <= 0) {
                    flag = false;
                }
            }

            if (flag) {
                submitBtn.style.backgroundColor = '#30398a';
                submitBtn.disabled = false;
            } else {
                submitBtn.style.backgroundColor = '#ccc';
                submitBtn.disabled = true;
            }
        }
    }
});
